<template>
  <div>
    <v-container fluid>
      <h1>Google Reviews</h1>
      <div class="card-curvey" v-for="(app,index) in apps">
        <v-layout row wrap>
          <v-flex xs6>
            <label>Project Name</label>
            <v-text-field
              class="mt-2"
              outline
              v-model="app.project_name"
            >
            </v-text-field>
          </v-flex>
          <v-flex>
            <label>Client ID</label>
            <v-text-field
              class="mt-2"
              outline
              v-model="app.client_id"
            >
            </v-text-field>
          </v-flex>
          <v-flex>
            <label>Client Secret</label>
            <v-text-field
              class="mt-2"
              outline
              v-model="app.client_secret"
            >
            </v-text-field>
          </v-flex>
          <v-flex>
            <label>Project ID</label>
            <v-text-field
              class="mt-2"
              outline
              v-model="app.project_id"
            >
            </v-text-field>
          </v-flex>
          <v-flex>
            <label>Topic Name</label>
            <v-text-field
              class="mt-2"
              outline
              v-model="app.topic_name"
            >
            </v-text-field>
          </v-flex>
          <v-flex>
            <label>Subscription Name</label>
            <v-text-field
              class="mt-2"
              outline
              v-model="app.subscription_name"
            >
            </v-text-field>
          </v-flex>
          <v-flex>
            <label>Redirect_uri</label>
            <v-text-field
              class="mt-2"
              outline
              v-model="app.redirect_uri"
            >
            </v-text-field>
          </v-flex>
          <v-layout>
            <v-flex xs6>
              <label>Escalation Queue Name</label>
              <v-select
                class="mt-1"
                :items="settings.queueNames"
                outline
                v-model="app.escalation_queue_name"
              >
              </v-select>
            </v-flex>
            <v-flex xs6>
              <label>Immediately Escalate</label>
              <v-switch
                v-model="app.immediately_escalate"
              >
              </v-switch>
            </v-flex>
          </v-layout>

        </v-layout>
        <div class="connectors">
          <google-connectors :app="app" v-if="app.client_id" />
        </div>
      </div>
      <v-btn
        large round flat block
        class="primary--text"
        @click="addNewApp"
      >
        <v-icon>add_circle_outline</v-icon>
        Add New App
      </v-btn>
    </v-container>
  </div>
</template>

<script>
  import googleConnectors from "./googleConnectors";
  import common from "../../../../utils/common";
  export default {
    name: "googleReview",
    components: {
      googleConnectors
    },
    data () {
      return {
        settings: {},
        apps: [

        ]
      }
    },
    mounted() {
      this.getApps()
      this.getSettings()
    },
    methods: {
      addNewApp() {
        this.apps.push(
          {
            'project_name': '',
            'client_id': '',
            'client_secret': '',
            'project_id': '',
            'topic_name': '',
            'subscription_name': '',
            'redirect_uri': '',
            'code': '',
            "immediately_escalate": true,
            "escalation_queue_name": ""
          }
        )
      },
      getApps() {
        this.$http_session_manager.get(`/bots/${this.$store.state.bot.botId}/apps/?channel=google-reviews`)
          .then(response=>{
            this.apps = response.data.data
          })
          .catch()
      },
      getSettings () {
        this.$http_bot.get('/settings/')
          .then(response=>{
            this.settings = response.data
            if (!this.settings.nlp) {
              this.settings.nlp = {}
            }
          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()
            }
          })
      }
    }
  }
</script>

<style scoped>

</style>
